import type { TFunction } from 'i18next';

export const LOADER_COLOR_BY_STATUS: Record<string, string> = {
    install: 'oklch(65% 0.184 86.047)',
    destroying: 'oklch(70.4% 0.191 22.216 / 0.8)',
    restoring: 'oklch(62.3% 0.214 259.815)',
    starting: '#7ce0a4',
    stopping: '#ff8b8f',
    rebooting: '#f5b945',
    resetting: '#f5b945',
    'backing-up': 'oklch(62.7% 0.265 303.9)',
    resizing: 'oklch(62.3% 0.214 259.815)',
};

export function getStatusText(status: string, t: TFunction): string {
    if (!status) return t('status:unknown');
    const key = `status:${status}`;
    const translated = t(key);
    if (translated && translated !== key) {
        return translated;
    }
    return status;
}

export const STATUS_BADGE: Record<string, { bg: string; fg: string }> = {
    running: { bg: '#10b98126', fg: 'var(--color-status-success)' },
    starting: { bg: '#10b98126', fg: 'var(--color-status-success)' },
    stopped: { bg: '#9ca3af26', fg: 'var(--color-status-neutral)' },
    stopping: { bg: '#ef444426', fg: 'var(--color-status-danger)' },
    rebooting: { bg: '#f59e0b26', fg: 'var(--color-status-warning)' },
    resetting: { bg: '#f59e0b26', fg: 'var(--color-status-warning)' },
    install: { bg: '#f59e0b26', fg: 'var(--color-status-warning)' },
    destroying: { bg: '#ef444426', fg: 'var(--color-status-danger)' },
    restoring: { bg: '#3b82f626', fg: 'var(--color-status-info)' },
    'backing-up': { bg: '#a78bfa26', fg: 'var(--color-status-violet)' },
    resizing: { bg: '#3b82f626', fg: 'var(--color-status-info)' },
};

export const DEFAULT_STATUS_BADGE = { bg: '#9ca3af26', fg: 'var(--color-status-neutral)' };

export const NON_NAVIGABLE_STATES = ['install', 'destroying', 'restoring'];

export const INSTANCE_NAME_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9\-_]*[a-zA-Z0-9])?$/;
